// extracted by mini-css-extract-plugin
export default {"recos":"d3-z","productCardOverride":"e3-z","rowHasBadge":"f3-z"};